module.exports = __webpack_public_path__ + "503103eb499ba47841f4f5bdd6786cbb.svg";